// extracted by mini-css-extract-plugin
module.exports = {"button-custom":"_base-button_button-custom_1-iPm"};